<mat-card>
    <img src="{{imgUrl}}" alt="banner-img">
    <div class="container-info-banner">
        <ng-content></ng-content>
    </div>
</mat-card>
